import Table from './table';
import './table.scss';

export default Table;